import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import SpinnerContainer from "../../../components/Spinner/SpinnerContainer.tsx";
import { useAppSelector } from "../../../services/hooks";
import {generateUrl} from "../../../helpers/routeHelper.ts";

export default function EmptyCart() {
    const { t, i18n } = useTranslation('cart');
    const productsLoading = useAppSelector((state) => state.cart.loading);

    return (
        <SpinnerContainer enabled={productsLoading}>
            {!productsLoading
                ? <Row className="my-3 align-items-center g-0">
                    <Col xs={12} md={6} className="text-end p-5 p-md-3">
                        <img src="/assets/img/emptyCart.png" className="img-fluid" alt="" />
                    </Col>
                    <Col xs={12} md={6} className="text-start px-5">
                        <p className="fs-3">
                            <strong>{t('empty.header')}</strong>
                        </p>
                        <p>
                            <strong>{t('empty.change')}</strong>
                        </p>
                        <p className="fs-5">
                            <strong>{t('empty.not_all')},</strong>
                        </p>
                        <p>{t('empty.find')}</p>
                        <p>
                            {t('empty.needs')}
                            <a href={generateUrl('category-map', i18n.language)} className="link-success">
                                <strong> {t('empty.categories')}</strong>
                            </a>,
                            <br />
                            {t('empty.help')}
                            <a href={generateUrl('contact', i18n.language)}className="link-success">
                                <strong> {t('empty.contact')}</strong>
                            </a>
                        </p>
                    </Col>
                </Row>
                : <Row>
                    <Col style={{ height: "50vh" }}></Col>
                </Row>
            }
        </SpinnerContainer>
    )
}

/* <div className="col-12  text-center">
<span className="py-2 mb-2 px-4 fs-3">Nie mamy wszystkiego w sklepie,  </span>
</div>
<p className="col-12 text-center pt-1"> ale znajdziemy to, czego szukasz, specjalnie dla Ciebie</p>
<div className="col-12  text-center">
<div className="svg-container">

<img src="/tpl/assets/img/emptyCart-arrow.svg" className="img-fluid  svg-object animate-svg-from-bottom thanksForShoping_1_object" alt="" />
<img src="/tpl/assets/img/emptyCart-girl.svg" className="img-fluid  svg-object animate-svg-from-top thanksForShoping_2_object" alt="" />
<img src="/tpl/assets/img/emptyCart-profispray.svg" className="img-fluid  svg-object animate-svg-from-top thanksForShoping_3_object" alt="" />
<p className="text-object    object-fade-emptybasket-page-txt fade-in-txt delayAnimObject4s">
<strong>Twój koszyk jest pusty</strong>
</p>

<p className="text-object  object-fade-emptybasket-page-txt2 fade-in-txt delayAnimObject4s">
Czas to zmienić
</p>

</div>
</div>
<p className="col-12 text-center small pt-1">
a może nie wiesz, czego potrzebujesz <a href="" className="link-dark"><strong>Zobacz kategorie naszych produktów</strong></a>,
jeśli potrzebujesz pomocy, odwiedź naszą sekcję <a href="" className="link-dark"><strong>Kontakt</strong></a>
</p> */